import { Tenant } from './../models/tenant.model';
import { Injectable } from '@angular/core';
import { SortConfiguration } from '../components/generics/data-table/data-table.component';
import { AuthService } from './auth.service';
import { UtilsService } from 'src/app/services/utils.service';
import { HttpClient } from '@angular/common/http';
import { ID } from '../models/ID.model';

@Injectable({
    providedIn: 'root'
})
export class TenantsService {

    constructor(
        private http: HttpClient,
        private utilsService: UtilsService,
        private authService: AuthService
    ) { }

    getTenants(page: number, itemsPerPage: number, sorts: SortConfiguration[], extraParams: any) {
        const url = '/inquilinos';
        const headers = {
            'page-number': String(page),
            'page-size': String(itemsPerPage)
        };
        const params = {
            'sort-by': this.utilsService.generateSortQueryParam(sorts)
        };
        const user = this.authService.getUser();
        if (user?.tipo === 'AGENTE') {
            params['id-agente'] = user.agente?.id;
        } else if (user?.tipo === 'OFICINA') {
            params['id-oficina'] = user.oficina?.id;
        }
        Object.assign(params, JSON.parse(JSON.stringify(extraParams)));
        return this.http.get<Tenant[]>(url, { headers, observe: 'response', params });
    }

    getTenantById(id: ID) {
        return this.http.get<Tenant>(`/inquilinos/${id}`);
    }

    checkAvailability(type: 'dni' | 'cuit' | 'pasaporte', identification: string) { // MODIFICADO
        return this.http.get<Tenant | undefined>(`/inquilinos/${type}/${identification}`);
    }

    editTenant(tenant: Tenant) {
        return this.http.put<Tenant>(`/inquilinos/${tenant.id}`, tenant);
    }
}
